<template>
	<!--底部-->
	<div class="footer">
		<div class="foot1 ovh">
			
			<div class="pull-left ww30">
				<a href="###" @click="enterIndex"><img class="logo" src="../../assets/images/1.png" alt=""></a>
			</div>
			<div class="pull-left ww27" >
				<p @click="enterAbout" class="fs20 m-fs18 s-fs16 x-fs14 cor595757">Support</p>
				<div class="abount1">
					<div class=" fs14 ww30 curp" @click="enterWarranty">Warranty</div>
					<div class=" fs14 ww30 curp" @click="enterShipment">Shipment</div>
					<div class=" fs14 ww30 curp" @click="enterBusinessScope">Business Scope</div>
				</div>	
			</div>
			<div class="pull-left ww25">
				<p @click="enterContactUs" class="fs20 m-fs18 s-fs16 x-fs14 cor595757 curp">CONTACT US</p>
				<div class="abount2">
					<div class="dinb fs14 ">
						<img class="dinb" src="../../assets/whatsapp.png" alt="">
						Whatsapp:
					</div>
					<div class="dinb fs14 ">+8613265815690</div>
				</div>
				<div class="abount2">
					<div class="dinb fs14 ">
						<img class="dinb" src="../../assets/email.png" alt="">
						Email:
					</div>
					<div class="dinb fs14">service@mi-mhl.com</div>
				</div>
			</div>

		</div>
		<div class="topNan2 pdt50">
			<p>©2020 hkcetd.com All rights reserved. MI TIME TECHNOLOGY CO.,LIMITED</p>
		</div>	
	</div>
	<!--底部-->
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {

    }
  },
  mounted () {

  },
  methods: {
    getHeight () {
      this.$emit("sendHeight", $(".header").css("height"))
    },
    enterIndex() {
      	this.$router.push({ path: '/cetd/index' })
    },
    enterProduct() {
      	this.$router.push({ path: '/cetd/product' })
    },
    enterAbout(){
      	this.$router.push({ path: '/cetd/about' })
    },
    enterContactUs(){
    	this.$router.push({ path: '/cetd/contactUs' })
    },
    enterWarranty(){
    	this.$router.push({ path: '/cetd/warranty' })
    },
    enterShipment(){
    	this.$router.push({ path: '/cetd/shipment' })
    },
    enterBusinessScope(){
    	this.$router.push({ path: '/cetd/businessScope' })
    }
  }
}
</script>

<style lang="scss" scoped>
.abount{
  padding-top: 10px;
}
.curp{
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/layout/components/Footer.vue